import React from 'react';
import { Section } from './ui/Section';
import { AlertCircle } from 'lucide-react';
export function ProblemSection() {
  return <Section className="bg-[#2D2D2D] text-white" data-id="element-116">
      <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-117">
        <div data-id="element-118">
          <div className="inline-flex items-center gap-2 text-[#D4735E] font-medium tracking-wider uppercase text-sm mb-4" data-id="element-119">
            <AlertCircle className="w-4 h-4" data-id="element-120" />
            El problema real
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-6 leading-tight" data-id="element-121">
            No es que todos los hombres sean iguales.
          </h2>
          <div className="space-y-4 text-gray-300 text-lg" data-id="element-122">
            <p data-id="element-123">No es tu cuerpo.</p>
            <p data-id="element-124">No es tu edad.</p>
          </div>
        </div>

        <div className="bg-white/5 backdrop-blur-sm p-8 rounded-2xl border border-white/10" data-id="element-125">
          <h3 className="text-xl font-serif text-[#D4735E] mb-4" data-id="element-126">
            Es este momento específico:
          </h3>
          <blockquote className="text-xl md:text-2xl italic leading-relaxed font-serif" data-id="element-127">
            “Ignoras la red flag porque te gusta. Te enamoras del potencial. Te
            vuelves la mujer cool. Esperas que cambie.”
          </blockquote>
        </div>
      </div>
    </Section>;
}